import { __rest } from "tslib";
import { useContext, useEffect, useState } from 'react';
import { PulseContext } from "./pulse-react.context.js";
const useLazyPulseSettings = ({ tag, name }) => {
    const { settings } = useContext(PulseContext);
    const [settingsData, setSettingsData] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [error, setError] = useState();
    if (!settings) {
        throw new Error('Cannot use "settings" hook, please add "settings" to sdks array when initializing the Provider');
    }
    return {
        loading,
        settings: settingsData,
        hasError,
        error,
        get: () => {
            setLoading(true);
            settings
                .getSettings({ tag, name })
                .then((result) => {
                setSettingsData(result);
                setLoading(false);
            })
                .catch((err) => {
                setHasError(true);
                setError(err);
                setLoading(false);
            });
        }
    };
};
const usePulseSettings = (input) => {
    const _a = useLazyPulseSettings(input), { get } = _a, rest = __rest(_a, ["get"]);
    useEffect(() => {
        get();
    }, []);
    return Object.assign({}, rest);
};
export { usePulseSettings, useLazyPulseSettings };
//# sourceMappingURL=use-pulse-settings.hook.js.map